/**
 * WriteToLog - To write console.logs into a file on the server 
 * and to send out emails to Admin when any error is detected
 *  */ 
async function WriteToLog(logText) {
  //const div = document.getElementById('log');
  //const p = document.createElement('p');
  //p.textContent = logText;
  //div.appendChild(p);

  /* 
  // TODO: Other hospitals to build this functionality
  var logUrl = "your server url to a log file";
  var emailUrl = "send email service url";
 
  let data = {
        "FileName": "PICU_EPIC",  
        "Message": logText, 
        "ErrorType": "Info"
  };

  let axiosConfig = {
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  };

  axios
    .post(logUrl, data, axiosConfig)
    .then((res) => {
    //console.log("WriteToLog response: " + JSON.stringify(res));
  })
    .catch((error) => {
    //console.log('WriteToLog error: ', error);
  });
    
  if(logText.includes("error")) {
  // Send Email to Admins
  let emailData = {
    "EMAIL": "email id",  
    "SUBJECT": "Airway Bundle Checklist Error", 
    "ERRORMESSAGE": logText
  };

  axios.post(emailUrl, emailData, axiosConfig)
    .then((response) => {
      //console.log("WriteToLog response: " + JSON.stringify(response));
    })
    .catch((error) => {
      //console.log('WriteToLog error: ', error);
    });
  }
  */

  return true;
}

export default WriteToLog;
